import React from 'react';
import Header from '../components/Header';
import Breadcrumb from '../components/Breadcrumb';
import ReferencesAndAuthor from '../components/ReferencesAndAuthor';
import Footer from '../components/Footer';

const references = [
  {
    title: 'Assessment of coma and impaired consciousness: a practical scale',
    citation: 'Teasdale G, Jennett B. Lancet. 1974;2(7872):81–84.',
    href: 'https://doi.org/10.1016/S0140-6736(74)91639-0',
    note: 'Publicação original da Escala de Coma de Glasgow.',
  },
  {
    title: 'The Glasgow Coma Scale at 40 years: standing the test of time',
    citation: 'Teasdale G, Maas A, Lecky F, Manley G, Stocchetti N, Murray G. Lancet Neurol. 2014;13(8):844–854.',
    href: 'https://pubmed.ncbi.nlm.nih.gov/25030516/',
    note: 'Revisão de 40 anos que reforça a descrição dos três componentes e o uso padronizado da escala.',
  },
  {
    title: 'Simplifying the use of prognostic information in traumatic brain injury. Part 1: The GCS-Pupils score',
    citation: 'Brennan PM, Murray GD, Teasdale GM. J Neurosurg. 2018;128(6):1612–1620.',
    href: 'https://pubmed.ncbi.nlm.nih.gov/29631516/',
    note: 'Trabalho que propõe o GCS-Pupils score (ECG-P) para ampliar a discriminação prognóstica em TCE.',
  },
  {
    title: 'The Glasgow Structured Approach to Assessment of the Glasgow Coma Scale',
    citation: 'Glasgow Coma Scale — recurso oficial.',
    href: 'https://www.glasgowcomascale.org/',
    note: 'Material oficial de avaliação estruturada, nomenclatura e recursos de treinamento.',
  },
];

function Referencias() {
  return (
    <div className="min-h-screen bg-gray-50 font-sans text-gray-900">
      <Header />
      <Breadcrumb />
      <main className="max-w-5xl mx-auto px-4 py-12">
        <span className="section-kicker">Fontes primárias e oficiais</span>
        <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight mt-2 mb-4 text-slate-800">Referências da Escala de Glasgow</h1>
        <p className="text-lg text-gray-600 mb-8">Principais fontes usadas para a escala adulta, aplicação estruturada e ECG-P.</p>

        <div className="space-y-5">
          {references.map((reference, index) => (
            <article key={reference.title} className="bg-white border border-slate-200 rounded-2xl p-6 md:p-8 shadow-sm">
              <span className="text-xs font-bold text-teal-700 uppercase tracking-wider">Referência {index + 1}</span>
              <h2 className="text-2xl font-bold mt-2 mb-2">{reference.title}</h2>
              <p className="text-gray-800 font-medium">{reference.citation}</p>
              <p className="text-gray-600 mt-3">{reference.note}</p>
              <a href={reference.href} target="_blank" rel="noopener noreferrer" className="text-teal-700 font-semibold inline-block mt-3">Abrir fonte ↗</a>
            </article>
          ))}
        </div>

        <section className="bg-slate-900 text-white rounded-2xl p-6 md:p-8 mt-8">
          <h2 className="text-2xl font-bold text-white mb-3">Como usar estas referências?</h2>
          <p className="text-slate-100">A calculadora é uma implementação prática; para ensino, protocolos locais, pesquisa ou discussão prognóstica, consulte as publicações originais e o material oficial. O site não substitui a leitura da fonte primária.</p>
        </section>

        <ReferencesAndAuthor />
      </main>
      <Footer />
    </div>
  );
}

export default Referencias;
